import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { decrementQuantity, incrementQuantity, removeFromCart } from "../store/slices/CartSlice";
import { useNavigate } from "react-router-dom";

const CartPage = () => {

  const cartItems = useSelector(state=>state.cart.cart)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleQuantityChange = (product) => {
    dispatch(incrementQuantity(product))
  };

  const handleQuantityLess = (product) => {
    dispatch(decrementQuantity(product))
  };
  // Handle removing item from the cart
  const handleRemoveItem = (product) => {
     dispatch(removeFromCart(product))
    // setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  // Calculate total price
  const total = cartItems.reduce(
    (sum, item) => sum + item.salePrice * item.quantity,
    0
  );

  return (
    <div className="w-full mx-auto px-5 md:px-10 py-10">
      <h1 className="text-xl font-bold mb-6">Your Shopping Cart</h1>
      <div className=" flex flex-col gap-2 md:flex-row justify-evenly">
        <div className=" md:w-1/2">
          {cartItems.length === 0 ? (
            <p className="text-center text-gray-500">Your cart is empty.</p>
          ) : (
            <div className="space-y-6">
              {cartItems.map((item) => (
                <div
                  key={item._id}
                  className="flex justify-between items-center p-4 bg-white border rounded-lg shadow-sm"
                >
                  <div className="w-36 h-36 ">
                    <img
                      src={item.images[0]}
                      alt={item.name}
                      className="w-full h-full object-cover rounded-lg"
                    />
                  </div>
                  <div className="flex-1 ml-6">
                    <h2 className="text-lg font-semibold">{item.name}</h2>
                    <p className="text-sm text-gray-600">
                      &#8377; {item.salePrice}
                       <span className=" line-through text-gray-700 font-normal text-[12px]">
                    &#8377; {item.price}
                  </span>
                    </p>
                    <div className="flex items-center space-x-4 mt-2">
                      <button
                        onClick={() =>
                          handleQuantityLess(item)
                        }
                        className="px-2 py-1 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                      >
                        -
                      </button>
                      <span className="text-sm font-semibold">
                        {item.quantity}
                      </span>
                      <button
                        onClick={() =>
                          handleQuantityChange(item)
                        }
                        className="px-2 py-1 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                      >
                        +
                      </button>
                    </div>
                    <button
                      onClick={() => handleRemoveItem(item)}
                      className="mt-4 px-2 py-1 text-[12px] bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="md:w-1/3 bg-white p-6 border rounded-lg shadow-sm h-fit">
          <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
          <div className="flex justify-between mb-2">
          <span className="text-gray-700">Items</span>
          <span className="font-semibold">{cartItems.length}</span>
        </div>
        <div className="flex justify-between mb-4">
          <span className="text-gray-700">Subtotal</span>
          <span className="font-semibold">&#8377; {total}</span>
        </div>
          <button className="w-full px-6 py-3 bg-primary text-white rounded-lg hover:bg-green-700" 
          onClick={()=>{
            localStorage.setItem("lastLoginPath","/checkout")
            navigate('/checkout')
            }
          }>
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
